export const RULES_COUNT = 255;

export const USER_LAW_ITEMS = [
  { id: -11, idUpper: 0, name: "Справочники", isGroup: true },
  { id: -2, idUpper: 0, name: "Настройки", isGroup: true },
  { id: -7, idUpper: 0, name: "Пакеты", isGroup: true },
  { id: -5, idUpper: 0, name: "Обмен", isGroup: true },
  { id: -10, idUpper: 0, name: "Администрирование", isGroup: true },
  { id: -4, idUpper: 0, name: "Облако", isGroup: true },
  { id: -12, idUpper: 0, name: "Документы", isGroup: true },
  { id: -1, idUpper: 0, name: "Счета, расчет", isGroup: true },
  { id: -9, idUpper: 0, name: "Скидки", isGroup: true },
  { id: -13, idUpper: 0, name: "Хранение", isGroup: true },
  { id: -14, idUpper: 0, name: "CRM", isGroup: true },
  { id: 45, idUpper: -11, name: "Контрагенты. Просмотр справочника, выбор" },
  { id: 46, idUpper: -11, name: "Контрагенты. Редактирование групп" },
  { id: 47, idUpper: -11, name: "Контрагенты. Редактирование реквизитов" },
  { id: 48, idUpper: -11, name: "Контрагенты. Редактирование" },
  { id: 36, idUpper: -11, name: "Контрагенты. Редактирование клиентов из счета" },
  { id: 1, idUpper: -11, name: "Сотрудники. Распределение прав" },
  { id: 49, idUpper: -11, name: "Валюты. Просмотр справочника" },
  { id: 50, idUpper: -11, name: "Валюты. Редактирование валют" },
  { id: 51, idUpper: -11, name: "Валюты. Редактирование курсов" },
  { id: 111, idUpper: -11, name: "Планирование. Просмотр" },
  { id: 112, idUpper: -11, name: "Планирование. Редактирование" },
  { id: 113, idUpper: -11, name: "Планирование. Превышение лимита планирования" },
  { id: 117, idUpper: -11, name: "Макросы" },
  { id: 128, idUpper: -11, name: "Шаблоны сообщений" },
  { id: 52, idUpper: -11, name: "Отделы. Просмотр" },
  { id: 53, idUpper: -11, name: "Отделы. Редактирование" },
  { id: 54, idUpper: -11, name: "Компании. Просмотр" },
  { id: 55, idUpper: -11, name: "Компании. Редактирование" },
  { id: 59, idUpper: -11, name: "Виды задач. Редактирование" },
  { id: 64, idUpper: -11, name: "Сложность изделий. Просмотр" },
  { id: 65, idUpper: -11, name: "Сложность изделий. Редактирование" },
  { id: 66, idUpper: -11, name: "Отчеты. Просмотр справочника" },
  { id: 67, idUpper: -11, name: "Отчеты. Редактирование справочника" },
  { id: 9, idUpper: -11, name: "Отчеты. Редактирование перед печатью" },
  { id: 60, idUpper: -11, name: "Служебные. Просмотр" },
  { id: 61, idUpper: -11, name: "Служебные. Типы домов. Редактирование" },
  { id: 63, idUpper: -11, name: "Служебные. Виды оплаты. Редактирование" },
  { id: 57, idUpper: -11, name: "Служебные. Бригады. Редактирование" },
  { id: 42, idUpper: -11, name: "Служебные. Статусы заказа. Редактирование" },
  { id: 108, idUpper: -11, name: "Служебные. Виды готовности заказов. Редактирование" },
  { id: 109, idUpper: -11, name: "Служебные. Источники обращений. Редактирование" },
  { id: 72, idUpper: -11, name: "Служебные. Типы группировки материалов. Редактирование" },
  { id: 110, idUpper: -11, name: "Служебные. Склад. Редактирование" },
  { id: 4, idUpper: -2, name: "Технологические настройки" },
  { id: 38, idUpper: -2, name: "Настройка событий" },
  { id: 69, idUpper: -2, name: "Материалы. Просмотр" },
  { id: 70, idUpper: -2, name: "Материалы. Редактирование групп" },
  { id: 71, idUpper: -2, name: "Материалы. Установка наценки на все группы" },
  { id: 73, idUpper: -2, name: "Материалы. Редактирование цен" },
  { id: 74, idUpper: -2, name: "Материалы. Редактирование материалов" },
  { id: 75, idUpper: -2, name: "Материалы. Выгрузка прайса" },
  { id: 76, idUpper: -2, name: "Материалы. Загрузка прайса" },
  { id: 77, idUpper: -2, name: "Материалы. Назначение поставщика" },
  { id: 125, idUpper: -2, name: "Материалы. Просмотр удаленных" },
  { id: 89, idUpper: -2, name: "Менять вид отбора по типу материалов в справочнике материалов" },
  { id: 98, idUpper: -2, name: "Типовые изделия" },
  { id: 139, idUpper: -2, name: "Тех. карты" },
  { id: 23, idUpper: -7, name: "Добавление в пакет" },
  { id: 26, idUpper: -7, name: "Отправка в пакет счета без даты готовности" },
  { id: 37, idUpper: -7, name: "Управление пакетами заказов (создание, изменение, удаление, отправка)" },
  { id: 91, idUpper: -7, name: "Отмена отправки пакета" },
  { id: 100, idUpper: -7, name: "Отправка чужих счетов" },
  { id: 101, idUpper: -7, name: "Отмена отправки чужих счетов" },
  { id: 103, idUpper: -7, name: "Отправка в пакет счета с просрочкой дебиторской задолженности" },
  { id: 20, idUpper: -5, name: "Обмен настройками" },
  { id: 82, idUpper: -5, name: "Загрузка пакет из файла" },
  { id: 83, idUpper: -5, name: "Работа с почтой" },
  { id: 25, idUpper: -10, name: "Настройки системы", comment: "Настройки работы с программой для всех рабочих станций" },
  { id: 27, idUpper: -10, name: "Настройка рабочего места" },
  { id: 78, idUpper: -10, name: "Сменить базу данных", comment: "Возможность менять путь до базы данных" },
  { id: 79, idUpper: -10, name: "Войти под другим пользователем" },
  { id: 43, idUpper: -10, name: "Создание резервной копии базы" },
  { id: 44, idUpper: -10, name: "Восстановление базы из резервной копии" },
  { id: 80, idUpper: -10, name: "Обновление справочников" },
  { id: 81, idUpper: -10, name: "Полная проверка базы" },
  { id: 96, idUpper: -10, name: "Удаленное отключение пользователей от базы" },
  { id: 21, idUpper: -10, name: "Перевод" },
  { id: 131, idUpper: -10, name: "Редактор SQL" },
  { id: 136, idUpper: -10, name: "Настройка ККМ" },
  { id: 137, idUpper: -10, name: "Платежный терминал" },
  { id: 138, idUpper: -10, name: "Заявки" },
  { id: 39, idUpper: -4, name: "Настройка входа" },
  { id: 40, idUpper: -4, name: "Настройка компании" },
  { id: 41, idUpper: -4, name: "Загрузка обновленных настроек" },
  { id: 90, idUpper: -4, name: "Получать заказы из облака" },
  { id: 99, idUpper: -4, name: "Видимость облачной панели" },
  { id: 35, idUpper: -12, name: "Заказы" },
  { id: 142, idUpper: -12, name: "Просмотр партий и заданий других отделов" },
  { id: 56, idUpper: -12, name: "Партии. Просмотр" },
  { id: 143, idUpper: -12, name: "Партии. Редактирование" },
  { id: 144, idUpper: -12, name: "Партии. Удаление" },
  { id: 121, idUpper: -12, name: "Партии. Активация" },
  { id: 122, idUpper: -12, name: "Партии. Деактивация" },
  { id: 130, idUpper: -12, name: "Партии. Безбумажные операции" },
  { id: 58, idUpper: -12, name: "Раскрой. Просмотр" },
  { id: 123, idUpper: -12, name: "Раскрой. Активация" },
  { id: 124, idUpper: -12, name: "Раскрой. Деактивация" },
  { id: 62, idUpper: -12, name: "Накладные. Просмотр" },
  { id: 114, idUpper: -12, name: "Накладные. Редактирование" },
  { id: 140, idUpper: -12, name: "Накладные. Удаление" },
  { id: 115, idUpper: -12, name: "Накладные. Активация" },
  { id: 116, idUpper: -12, name: "Накладные. Деактивация" },
  { id: 68, idUpper: -12, name: "Задачи" },
  { id: 84, idUpper: -12, name: "Пакеты заказов" },
  { id: 97, idUpper: -12, name: "Действия пользователей" },
  { id: 126, idUpper: -12, name: "Изменение менеджера" },
  { id: 132, idUpper: -12, name: "Маршруты. Просмотр" },
  { id: 133, idUpper: -12, name: "Маршруты. Редактирование" },
  { id: 134, idUpper: -12, name: "Маршруты. Активация" },
  { id: 135, idUpper: -12, name: "Маршруты. Деактивация" },
  { id: 5, idUpper: -1, name: "Корректировка цены на изделия вручную" },
  { id: 6, idUpper: -1, name: "Корректировка спецификации изделия вручную" },
  { id: 7, idUpper: -1, name: "Спецификация на изделие (просмотр)" },
  { id: 8, idUpper: -1, name: "Редактирование шапки заказа со статусом \"Готов\"" },
  { id: 95, idUpper: -1, name: "Редактирование шапки заказа, отправленного в пакет заказов" },
  { id: 22, idUpper: -1, name: "Внесение оплат" },
  { id: 11, idUpper: -1, name: "Изменение оплат" },
  { id: 13, idUpper: -1, name: "Редактирование счетов" },
  { id: 14, idUpper: -1, name: "Установка статуса \"Готов\"" },
  { id: 15, idUpper: -1, name: "Редактирование чужих счетов" },
  { id: 16, idUpper: -1, name: "Видеть все счета" },
  { id: 141, idUpper: -1, name: "Видеть заказы всех отделов" },
  { id: 18, idUpper: -1, name: "Ручное изменение курса счета" },
  { id: 24, idUpper: -1, name: "Изменение даты выписки счета" },
  { id: 28, idUpper: -1, name: "Редактирование оплаченных счетов." },
  { id: 29, idUpper: -1, name: "Отправка в пакет счета без статуса \"Готов\"" },
  { id: 30, idUpper: -1, name: "Снятие статуса \"Готов\"" },
  { id: 31, idUpper: -1, name: "Редактирование оплат без статуса \"Готов\"" },
  { id: 33, idUpper: -1, name: "Оформление счета без клиента" },
  { id: 34, idUpper: -1, name: "Добавлять аксессуары в CAD системе" },
  { id: 92, idUpper: -1, name: "Ручная корректировка цены аксессуаров при продаже" },
  { id: 93, idUpper: -1, name: "Ручная корректировка цены работ при продаже" },
  { id: 94, idUpper: -1, name: "Произвольная дата платежа" },
  { id: 104, idUpper: -1, name: "Разрешать сохранять изделия с ошибками" },
  { id: 129, idUpper: -1, name: "Сообщения" },
  { id: 12, idUpper: -9, name: "Не ограничивать скидки" },
  { id: 17, idUpper: -9, name: "Редактирование скидок" },
  { id: 32, idUpper: -9, name: "Назначение скидок клиенту" },
  { id: 3, idUpper: -9, name: "Просмотр закупочных цен" },
  { id: 85, idUpper: -9, name: "Установки скидки процентом на счет" },
  { id: 86, idUpper: -9, name: "Установки скидки процентом на изделия" },
  { id: 87, idUpper: -9, name: "Установки скидки процентом на аксессуары" },
  { id: 88, idUpper: -9, name: "Установки скидки процентом на работы" },
  { id: 102, idUpper: -13, name: "Остатки раскроя" },
  { id: 105, idUpper: -13, name: "Тележки" },
  { id: 106, idUpper: -13, name: "Склад материалов" },
  { id: 107, idUpper: -13, name: "Готовая продукция" },
  { id: 118, idUpper: -14, name: "Звонки" },
  { id: 119, idUpper: -14, name: "Сделки" },
  { id: 120, idUpper: -14, name: "План-факт" },
  { id: 127, idUpper: -14, name: "Редактирование плана продаж" }
];

export const normalizeLaw = (law) => String(law || "").padEnd(RULES_COUNT, "1").slice(0, RULES_COUNT);

export const checkedKeysFromLaw = (law) => {
  const normalized = normalizeLaw(law);
  return USER_LAW_ITEMS
    .filter((item) => !item.isGroup && normalized[item.id - 1] === "1")
    .map((item) => String(item.id));
};

export const lawFromCheckedKeys = (checkedKeys) => {
  const checked = new Set((checkedKeys || []).map(String));
  const chars = Array.from({ length: RULES_COUNT }, () => "0");
  USER_LAW_ITEMS.forEach((item) => {
    if (!item.isGroup && checked.has(String(item.id))) {
      chars[item.id - 1] = "1";
    }
  });
  return chars.join("");
};

export const buildLawTreeData = () => {
  const groups = USER_LAW_ITEMS.filter((item) => item.isGroup);
  const rules = USER_LAW_ITEMS.filter((item) => !item.isGroup);
  return groups.map((group) => ({
    key: `group:${group.id}`,
    title: group.name,
    children: rules
      .filter((item) => item.idUpper === group.id)
      .map((item) => ({
        key: String(item.id),
        title: item.name,
        comment: item.comment || ""
      }))
  }));
};

/** Ключи листьев дерева прав (не группы), для «Отметить все». */
export const allLawLeafKeys = () => USER_LAW_ITEMS.filter((item) => !item.isGroup).map((item) => String(item.id));
